import { createEnum } from '../helpers'

/**
 * What captured a CRT period's copy of the SAP price list. The worker captures on the 1st
 * (`scheduled_capture`) and replaces the copy on the 5th (`scheduled_refresh`, which also captures a period
 * that has none); a user can replace it from the price list page (`manual`), which is also how a period
 * that predates the feature gets its copy.
 */
export const PRICE_LIST_SNAPSHOT_TRIGGERS = [
  'scheduled_capture',
  'scheduled_refresh',
  'manual',
] as const
export const PRICE_LIST_SNAPSHOT_TRIGGER_TYPES = createEnum(PRICE_LIST_SNAPSHOT_TRIGGERS)
export type PriceListSnapshotTrigger = (typeof PRICE_LIST_SNAPSHOT_TRIGGERS)[number]

/** `capture` leaves an existing copy alone; `refresh` replaces it and recomputes the period's versions. */
export const PRICE_LIST_SNAPSHOT_MODES = ['capture', 'refresh'] as const
export type PriceListSnapshotMode = (typeof PRICE_LIST_SNAPSHOT_MODES)[number]
